export class AppConstants {
   
}  

export const Operation = 'Operation';

export const Restriction = 'Restriction';